import CustomEditor from "components/TipTapEditor/CustomeEditor";
import { FieldArray, useField, useFormikContext } from "formik";
import useModal from "hooks/useModal";
import React, { useEffect, useRef, useState } from "react";
import parse from "html-react-parser";
import threDots_img from "Assets/images/three-dots.png";
import { Accordion, Col, Dropdown, Row, Table } from "react-bootstrap";
import { SINGLE_ASSESSMENT_PLAN_FIELD } from "helpers/assessment";
import AddAssessmentPop from "../Modals/AddAssessmentPop";
import { cloneDeep } from "lodash";
import { dateFormat } from "helpers/common";
import { MAX_REPORT_ASSESSMENTS, reportDateFormat } from "config/constants";
import confirmDialogV2 from "utils/confirmationDialogV2";
import AssessmentTable from "../AssessmentTable/AssessmentTable";

const QuestionAssessments = ({ fieldName, question, fieldData, previewMode, clientType, assessmentId, ...props }) => {
    const [field, meta] = useField(props.fieldName);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const { setFieldValue, values } = useFormikContext();
    const [activeKey, setActiveKey] = useState(0);
    const [showDropdown, setShowDropdown] = useState(null);
    const dropdownRefs = useRef([]);

    // Dropdown toggle handler
    const toggleDropdown = (e, index) => {
        e.stopPropagation();
        setShowDropdown(showDropdown === index ? null : index);
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (
                showDropdown !== null &&
                dropdownRefs.current[showDropdown] &&
                !dropdownRefs.current[showDropdown].contains(event.target)
            ) {
                setShowDropdown(null);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [showDropdown]);

    // save template modal
    const { show, data, open, close } = useModal();

    const handleSelectAssessment = (selected, index, editMode = false) => {
        const existingValues = cloneDeep(values[fieldName]);

        const newData = editMode ? {
            assessment_date: selected.date,
            title: selected?.assessment?.value?.title,
            answers: selected?.assessment?.value?.description,
            chartData: selected?.assessment?.value?.chartData,
        } : {
            ...SINGLE_ASSESSMENT_PLAN_FIELD,
            assessment_date: selected.date,
            title: selected?.assessment?.value?.title,
            answers: selected?.assessment?.value?.description,
            chartData: selected?.assessment?.value?.chartData,
        };

        if (typeof index === "number" && existingValues[index]) {
            // replace at index
            existingValues[index] = {
                ...existingValues[index],
                ...newData,
            };
            setActiveKey(index);
        } else {
            // add new
            existingValues.push(newData);
            setActiveKey(existingValues.length - 1);
        }

        console.log("existingValues >>>", existingValues);
        setFieldValue(fieldName, existingValues);
    };


    const handleChangeAssessment = async (e, index, assessment) => {
        // e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "CHANGE ASSESSMENT",
            message: "Are you sure you want to CHANGE the assessment you have chosen for this report? All information will be lost.",
        });
        if (!isConfirm) {
            return;
        }
        open({ index, assessment })
    }

    const handleEditAssessment = async (e, index, assessment) => {
        open({ index, assessment, editMode: true })
    }

    const handleRemoveAssessment = async (e, index, remove) => {
        // e.stopPropagation();
        const isConfirm = await confirmDialogV2({
            title: "DELETE ASSESSMENT",
            message: "Are you sure you want to DELETE this assessment from your report? All information will be lost.",
        });
        if (!isConfirm) {
            return;
        }
        remove(index)
    }


    return (
        <div>
            <AddAssessmentPop
                showPopup={show}
                closePopup={close}
                onSubmit={handleSelectAssessment}
                data={data}
            />
            <FieldArray name={fieldName}>
                {({ remove }) => (
                    <>
                        {values[fieldName]?.length > 0 && (
                            <div className="goals goals-accordion assessment-report" style={{ borderBottom: "0.75px solid #315D99", paddingBottom: "28px" }}>
                                <Accordion onClick={(e) => e.stopPropagation()} activeKey={activeKey} onSelect={(key) => setActiveKey(key)}>
                                    {values[fieldName]?.map((assessment, index) => (
                                        <React.Fragment key={index}>
                                            {console.log("assessment >>>", assessment)}
                                            <Accordion.Item className="border-0 my-2" eventKey={index} key={index}>
                                                <Accordion.Header style={{ borderBottom: "0.75px solid transparent" }}>
                                                    <div style={{ padding: "10px 0px 10px 18px", width: "100%" }}>
                                                        <div className='d-flex justify-content-between w-100 salign-items-center' style={{ borderBottom: "1px solid #315D99" }}>
                                                            <div>
                                                                <div className='' style={{ fontWeight: 700, color: "#315D99", fontSize: "14px" }}>
                                                                    <span className="text-uppercase proxima-regular">Assessment {index + 1}</span>:{" "}
                                                                    <span className="" style={{ fontWeight: 300 }}>{dateFormat(assessment?.assessment_date, reportDateFormat)}</span>
                                                                </div>
                                                            </div>
                                                            <div style={{ marginRight: "10px" }}>
                                                                <div
                                                                    ref={(el) => (dropdownRefs.current[index] = el)}
                                                                    className="cstm-dropdownclass"
                                                                >
                                                                    <Dropdown show={showDropdown === index}>
                                                                        <Dropdown.Toggle
                                                                            className="dropdown-custom-toggle"
                                                                            as="span" onClick={(e) => {
                                                                                e.stopPropagation();
                                                                            }} id={`dropdown-${index}`} >
                                                                            <img onClick={(e) => toggleDropdown(e, index)}
                                                                                width={19} height={18} src={threDots_img} alt="threDots_img" />
                                                                        </Dropdown.Toggle>
                                                                        <Dropdown.Menu onClick={(e) => e.stopPropagation()}>
                                                                            <Dropdown.Item onClick={(e) => handleEditAssessment(e, index, assessment)}>Edit Assessment</Dropdown.Item>
                                                                            <Dropdown.Item onClick={(e) => handleChangeAssessment(e, index, assessment)}>Change Assessment</Dropdown.Item>
                                                                            <Dropdown.Item onClick={(e) => handleRemoveAssessment(e, index, remove)}>Delete Assessment</Dropdown.Item>
                                                                        </Dropdown.Menu>
                                                                    </Dropdown>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div style={{ paddingTop: "16px" }}>
                                                            <Row>
                                                                <Col lg="4">
                                                                    <h6 className="proxima-regular black">{assessment.title}</h6>
                                                                </Col>
                                                                <Col lg="8">
                                                                    <p className="mb-0" style={{ fontSize: "12px", color: "#071E3E", fontWeight: 400, lineHeight: "1.4" }}>{parse(assessment.answers || "")}</p>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </div>
                                                </Accordion.Header>
                                                <Accordion.Body>
                                                    {assessment.chartData && (
                                                        <div className="assessments">
                                                            <h6 className="section-title-blue mb-0">ASSESSMENT DETAILS</h6>
                                                            <AssessmentTable
                                                                key={index}
                                                                data={assessment.chartData}
                                                                fieldName="assessment_plans"
                                                                index={index}
                                                            />
                                                        </div>
                                                    )}
                                                    <Row className="mb-4 slider-text-area mt-4">
                                                        <Col lg="4">
                                                            <h6 className="section-title-blue mb-0">
                                                                ASSESSMENT SUMMARY
                                                            </h6>
                                                            <p style={{ fontStyle: "italic", color: "#071E3E" }}>{question.template}</p>
                                                        </Col>
                                                        <Col lg="8" className="session-input-radio text-area-report">
                                                            <Row>
                                                                <Col lg="12">
                                                                    <div className="">
                                                                        <CustomEditor
                                                                            name={`${fieldName}.${index}.summary.answer`}
                                                                            attachmentName={`${fieldName}.${index}.summary.attachmentData`}
                                                                            limit={2500}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 mt-4 slider-text-area">
                                                        <Col lg="4">
                                                            <h6 className="section-title-blue mb-0">
                                                                ADDITIONAL INFORMATION
                                                            </h6>
                                                            <p style={{ fontStyle: "italic" }}>{`Share more information about the strengths and areas of challenge found from this assessment`}</p>
                                                        </Col>
                                                        <Col lg="8" className="session-input-radio text-area-report">
                                                            <Row>
                                                                <Col lg="12">
                                                                    <div className="">
                                                                        <CustomEditor
                                                                            name={`${fieldName}.${index}.additional_information.answer`}
                                                                            limit={4000}
                                                                        // attachmentName={`${fieldName}.${index}.diagnosis_severity.attachmentData`}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                    <Row className="mb-4 mt-4 slider-text-area">
                                                        <Col lg="4">
                                                            <h6 className="section-title-blue mb-0">
                                                                DIAGNOSIS & SEVERITY
                                                            </h6>
                                                            <p style={{ fontStyle: "italic" }}>{question.placeholder}</p>
                                                        </Col>
                                                        <Col lg="8" className="session-input-radio text-area-report">
                                                            <Row>
                                                                <Col lg="12">
                                                                    <div className="">
                                                                        <CustomEditor
                                                                            name={`${fieldName}.${index}.diagnosis_severity.answer`}
                                                                        // attachmentName={`${fieldName}.${index}.diagnosis_severity.attachmentData`}
                                                                        />
                                                                    </div>
                                                                </Col>
                                                            </Row>
                                                        </Col>
                                                    </Row>
                                                </Accordion.Body>
                                            </Accordion.Item>
                                        </React.Fragment>
                                    ))}
                                </Accordion>
                            </div>
                        )}
                        {values[fieldName]?.length < MAX_REPORT_ASSESSMENTS ? (
                            <div style={{ backgroundColor: "#EEFDFF", padding: "10px 0px 10px 18px" }}>
                                <div className='d-flex aalign-items-center justify-content-between w-100 align-items-center' style={{ borderBottom: "0.75px solid #315d99", }}>
                                    <div>
                                        <div className='proxima-regular' style={{ fontWeight: 700, color: "#315D99" }}>
                                            <span className="text-uppercase">Assessment {(values[fieldName]?.length || 0) + 1}</span>
                                        </div>
                                    </div>
                                </div>
                                <div className="d-flex mt-3 align-items-center gap-3">
                                    <button
                                        type="button"
                                        className="blue-btn"
                                        onClick={() =>
                                            open()
                                        }
                                    >
                                        Add Assessment
                                    </button>
                                    <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. 4 per plan.</p>
                                </div>
                            </div>
                        ) : (
                            <p className="mb-0" style={{ color: "#071E3E", fontSize: "14px", fontStyle: "italic" }}>Max. 4 per plan.</p>
                        )}
                    </>
                )}
            </FieldArray>
        </div>
    );
};

export default QuestionAssessments;

